import React from 'react';
import { KibButtonNew } from '@chewy/kib-controls-react';
import { KibAddIcon } from '@chewy/kib-icons-react';
import ImageUpload from '../image-upload/ImageUpload';
import './pet-avatar-button.scss';

export const PetAvatarUploadButton = ({
  click,
  onError,
}: {
  click: (key: Blob) => void;
  onError?: () => void;
}) => (
  <ImageUpload onCompleteCrop={click} onError={onError} title="Upload Avatar Image">
    <KibButtonNew className="pet-avatar-upload-button" icon={<KibAddIcon />} emphasis="secondary">
      Upload a Photo
    </KibButtonNew>
  </ImageUpload>
);
